import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import useFeature from '../SystemSettings/hooks/featureFlags/useFeature';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';

export function useSuportLoginDisabled(): boolean {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode) as any;
    return systemMode === SYSTEM_MODES.ON_PREM;
}
